// @flow
import React, { type Node } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Table, Tr, Th } from 'app/common/ui-components/table';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';

import styles from './TableHeadFixed.scss';


type Props = {
  className?: string,
}

const TableHeadFixed = ({ className }: Props): Node => {
  const { t } = useTranslation('dnevnik');
  const head = t('column_subjects2');

  return (
    <Table className={cn(styles.root, className)}>
      <thead>
        <Tr header>
          <Th
            className={styles.th}
            contentClassName={styles.thContent}
            stripPadding
          >
            <PlainTooltip text={head} hideWithoutOverflow>
              {head}
            </PlainTooltip>
          </Th>
        </Tr>
      </thead>
    </Table>
  );
};

export default TableHeadFixed;
